import { Component, Output, OnInit, EventEmitter, ViewEncapsulation, Input, SimpleChanges, AfterViewInit } from '@angular/core';

import { TreeSelectionModel } from './tree-selection.model';

@Component({
    selector: 'countries-tree-selection-modal',
    templateUrl: 'country-tree-selection-modal.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CountryTreeSelectionModalComponent implements OnInit, AfterViewInit {
    @Input()
    values: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();
    itemsSelectedCount: number = 0;

    @Output()
    valueChange: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();;

    constructor() {
    }

    ngOnInit() {
        this.values = this.values || new Array<TreeSelectionModel>();
        this.setCountries();
    }

    onSave() {
        let items = $("#countries-select").next().find("[class='selected']").find("[class='item']");
        let result = Array<number>();
        if (items)
            for (var i = 0; i < items.length; i++) {
                result.push($(items[i]).data("value"));
            }

        if (result.length !== 0) {
            $('#treeCountriesFilter').modal('hide');
            this.valueChange.emit(result);
        }
    }

    resetSelection() {
        $("#countries-select").next().find("[class='select-all-container']").find("span:first").click();
    }

    onClose() {
        $('#treeCountriesFilter').modal('hide');
    }

    private setConfigForSelection() {
        this.values.forEach(s => s.isSelected = null);
        this.itemsSelectedCount = $("#countries-select").next().find("[class='selected']").find("[class='item']").length;
        setInterval(() => {
            this.itemsSelectedCount = $("#countries-select").next().find("[class='selected']").find("[class='item']").length;
        }, 300);
    }

    public setCountries() {
        $('.tree-multiselect').empty();
        this.setConfigForSelection();
    }

    ngOnChanges(changes: any): void {
        this.setCountries();
    }

    ngAfterViewInit() {
        $("#countries-select").treeMultiselect({ enableSelectAll: true, sortable: false });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/country-tree-selection-modal.component.ts